import { ISigninLog } from '@api/types/sign-in.type';
import http from 'httpConfig/http';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';

export const getAllUserSigninLogs = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/users/logs?startDate=${startDate}&endDate=${endDate}`
    );
    return data as ISigninLog[];
};
